import React from 'react';
import { FadeIn } from './FadeIn';
export function TheSystem() {
  const tomos = [{
    num: '01',
    title: 'Fundamentos del Método Hybrid 360',
    desc: 'La base conceptual que cambia tu forma de entender el entrenamiento. Qué es el atleta híbrido, por qué los métodos tradicionales fallan, los 6 pilares del sistema y los principios científicos que sostienen cada decisión de programación.'
  }, {
    num: '02',
    title: 'Capacidades Físicas del Atleta Híbrido',
    desc: 'Cómo desarrollar fuerza, resistencia, hipertrofia funcional, movilidad y potencia dentro del mismo sistema. Cada capacidad tiene su protocolo, sus herramientas y su lugar dentro de la semana híbrida.'
  }, {
    num: '03',
    title: 'Programación y Periodización',
    desc: 'Tu entrenamiento tiene lógica, bloques y progresión real. Microciclos, mesociclos, macrociclos, deload programado y planes de 8 semanas listos para aplicar según tu nivel y objetivo.'
  }, {
    num: '04',
    title: 'Nutrición, Recuperación y Prevención',
    desc: 'Cómo comer para rendir en fuerza Y resistencia, suplementación con evidencia real, protocolo de sueño, herramientas de recuperación activa y prevención de las lesiones más frecuentes del atleta híbrido.'
  }, {
    num: '05',
    title: 'Escudo Inmunológico',
    desc: 'Por qué el entrenamiento intenso abre una ventana de vulnerabilidad inmune y cómo cerrarla. Nutrición inmunológica, gestión del cortisol, protocolos de blindaje y planes de acción listos por nivel y objetivo.'
  }, {
    num: '06',
    title: 'Identidad Híbrida',
    desc: 'La mentalidad, la disciplina y los hábitos que sostienen el sistema a largo plazo. Identidad del atleta híbrido, adherencia real, cómo volver después de pausas y cómo integrar el entrenamiento con la vida real.'
  }];
  return <section className="py-20 sm:py-32 px-4 bg-carbon-900 border-t border-carbon-800" data-id="element-224">
      <div className="max-w-6xl mx-auto" data-id="element-225">
        <FadeIn data-id="element-226">
          <div className="flex items-center gap-4 mb-12" data-id="element-227">
            <span className="font-display text-4xl text-carbon-800" data-id="element-228">03</span>
            <div className="h-px bg-carbon-800 flex-grow" data-id="element-229" />
            <span className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-230">
              El Sistema
            </span>
          </div>

          <div className="mb-16 max-w-4xl" data-id="element-231">
            <h2 className="text-5xl sm:text-7xl font-display text-white mb-8 uppercase tracking-wide leading-[0.9]" data-id="element-232">
              EL <span className="text-electric" data-id="element-233">MÉTODO HYBRID 360</span>
              <br data-id="element-234" />
              ES ESE SISTEMA.
            </h2>
            <div className="prose prose-invert prose-lg max-w-none font-sans text-carbon-300" data-id="element-235">
              <p data-id="element-236">
                No es una colección de PDFs sueltos. No es contenido de YouTube
                organizado en documentos. No es una rutina más sin contexto.
              </p>
              <p data-id="element-237">
                Es el sistema completo para transformarte en un atleta híbrido.
                De los fundamentos conceptuales hasta la mentalidad de largo
                plazo. De la programación semanal hasta la nutrición que
                potencia el rendimiento.
              </p>
              <p className="text-white font-semibold text-xl border-l-2 border-electric pl-4 mt-8" data-id="element-238">
                Todo conectado. Todo con criterio. Todo listo para usar desde
                hoy.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-239">
          <div className="font-mono text-sm text-electric uppercase tracking-widest mb-8 flex items-center gap-4" data-id="element-240">
            <span data-id="element-241">Los 6 tomos del sistema</span>
            <div className="h-px bg-electric/30 flex-grow" data-id="element-242" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-243">
          {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-244">
              <div className="bg-carbon-950 border border-carbon-800 rounded-3xl p-8 h-full relative group hover:bg-carbon-900 transition-colors flex flex-col overflow-hidden" data-id="element-245">
                <div className="absolute top-0 right-0 p-4" data-id="element-246">
                  <span className="font-display text-6xl text-carbon-800 group-hover:text-carbon-700 transition-colors leading-none" data-id="element-247">
                    {tomo.num}
                  </span>
                </div>
                <div className="mt-12 flex-grow" data-id="element-248">
                  <span className="font-mono text-xs text-electric uppercase tracking-widest mb-3 block" data-id="element-249">
                    Tomo {tomo.num}
                  </span>
                  <h4 className="text-2xl font-display text-white mb-4 uppercase tracking-wide pr-8" data-id="element-250">
                    {tomo.title}
                  </h4>
                  <p className="text-carbon-400 font-sans leading-relaxed text-sm" data-id="element-251">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}